$(document).ready(function(){
  $('.scrollon').on('click', function(e){
    e.preventDefault();
    var aid = $(this).attr('href');
    $('html,body').animate({scrollTop: $(aid).offset().top-100},'slow');
  });
});

/* Desplegable Mayoreo / Distribucion (header) */
(function () {
  var DIST_URL = '/pages/distribuidor-creme';
  var DIST_LABEL = 'Distribución';
  var MAYOREO_LABEL = 'Mayoreo';
  function injectStyle() {
    if (document.getElementById('mayoreo-dd-style')) return;
    var css = '.header-mayoreo-dd{position:relative;display:inline-block}'
      + '.header-mayoreo-dd>summary{list-style:none;cursor:pointer;display:inline-flex;align-items:center;gap:.4em}'
      + '.header-mayoreo-dd>summary::-webkit-details-marker{display:none}'
      + '.header-mayoreo-dd__caret{display:inline-block;width:.45em;height:.45em;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg);transition:transform .2s;margin-left:.15em;position:relative;top:-.12em}'
      + '.header-mayoreo-dd[open] .header-mayoreo-dd__caret{transform:rotate(-135deg);top:.05em}'
      + '.header-mayoreo-dd__menu{position:absolute;top:calc(100% + 6px);left:0;min-width:100%;white-space:nowrap;margin:0;padding:.35rem 0;list-style:none;background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:10px;box-shadow:0 10px 28px rgba(0,0,0,.14);z-index:1001}'
      + '.header-mayoreo-dd__menu li{list-style:none;margin:0}'
      + '.header-mayoreo-dd__menu a{display:block;padding:.6rem 1.2rem;text-decoration:none;color:#2b2b2b;font-size:.92em;line-height:1.2;font-weight:500}'
      + '.header-mayoreo-dd__menu a:hover{background:rgba(0,0,0,.05)}';
    var s = document.createElement('style');
    s.id = 'mayoreo-dd-style';
    s.textContent = css;
    document.head.appendChild(s);
  }
  function buildDropdowns() {
    var anchors = document.querySelectorAll('a.button-header.button--secondary:not([data-mayoreo-done])');
    if (!anchors.length) return;
    injectStyle();
    anchors.forEach(function (a) {
      a.setAttribute('data-mayoreo-done', '1');
      var triggerLabel = (a.textContent || MAYOREO_LABEL).trim();
      var mayoreoHref = a.getAttribute('href') || '#';
      var details = document.createElement('details');
      details.className = 'header-mayoreo-dd';
      var summary = document.createElement('summary');
      summary.className = a.className;
      summary.appendChild(document.createTextNode(triggerLabel));
      var caret = document.createElement('span');
      caret.className = 'header-mayoreo-dd__caret';
      caret.setAttribute('aria-hidden', 'true');
      summary.appendChild(caret);
      var ul = document.createElement('ul');
      ul.className = 'header-mayoreo-dd__menu';
      ul.setAttribute('role', 'list');
      var li1 = document.createElement('li');
      var a1 = document.createElement('a');
      a1.href = mayoreoHref;
      a1.textContent = MAYOREO_LABEL;
      li1.appendChild(a1);
      var li2 = document.createElement('li');
      var a2 = document.createElement('a');
      a2.href = DIST_URL;
      a2.textContent = DIST_LABEL;
      li2.appendChild(a2);
      ul.appendChild(li1);
      ul.appendChild(li2);
      details.appendChild(summary);
      details.appendChild(ul);
      a.parentNode.replaceChild(details, a);
    });
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.header-mayoreo-dd[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildDropdowns);
  } else {
    buildDropdowns();
  }
  document.addEventListener('shopify:section:load', buildDropdowns);
})();
